import '../../../sass/screens/email_sent/index.scss';
import { initializeForm } from '../../utils/form';
import { NEWSLETTER_SUBSCRIPTION_EVENTS } from '../../event_bus_modules/newsletter_subscription';
import recaptcha, { getPublicKeyOfScope } from '../../utils/recaptcha';

$(() => {
  const $newsletterSubscriptionForm = $('#newsletter-subscription-form');
  const $newsletterSubscriptionSubmitButton = $(
    '#newsletter-subscription-submit'
  );
  const subscriptionCompleteMessage = $('#newsletter-subscription-complete');
  const csrfToken = $newsletterSubscriptionForm
    .find('input[name="csrfmiddlewaretoken"]')
    .val();
  const $formInputs = $newsletterSubscriptionForm.find(
    'input[type=hidden].country'
  );
  const submitUrl = $newsletterSubscriptionForm.attr('action');
  // buttons
  const $countryButtons = $('button.country-button');

  initializeForm($newsletterSubscriptionForm, {
    preventDefault: true,
  });

  $countryButtons.on('click', () => {
    disableJoinMailingListIfNoCountryIsSelected();
  });

  const disableJoinMailingListIfNoCountryIsSelected = () => {
    const totalSelected = $($newsletterSubscriptionForm).find(
      'input[value=true].country'
    ).length;
    if (totalSelected === 0)
      $newsletterSubscriptionSubmitButton.attr('disabled', 'disabled');
    else $newsletterSubscriptionSubmitButton.removeAttr('disabled');
  };

  $newsletterSubscriptionSubmitButton.on('click', () => {
    recaptcha(getPublicKeyOfScope('#newsletter-subscription-form')).then(
      (recaptchaResponseToken) => {
        const email = $('#email').val();
        let payload = {
          email: email,
          'g-recaptcha-response': recaptchaResponseToken,
        };

        $formInputs.each((_, formInput) => {
          payload[$(formInput).attr('name')] = $(formInput).val() === 'true';
        });

        EVENT_BUS.dispatch(
          NEWSLETTER_SUBSCRIPTION_EVENTS.NEWSLETTER_SUBSCRIPTION_CONFIRMED,
          { submitUrl, payload, csrfToken }
        );

        $newsletterSubscriptionForm.hide();
        subscriptionCompleteMessage.removeClass('d-none');

        $(window).scrollTop(0);
        setTimeout(() => {
          window.location = '/';
        }, 3000);
      }
    );
  });
});
